module.exports = __webpack_public_path__ + "img/antes_despues_198.7525d210.png";